import React from 'react';
import {noop} from 'lodash';

import ClientRole from '/component/partial/report/ClientRole';
import ClientsListHeader from '/component/partial/report/ClientsListHeader';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {generateOnRecordPress} from './AllOrganizationClientsReport.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

interface AllOrganizationClientsContentProps {
  loadingData: {
    total?: number;
  };
  showRecordPopover: () => void;
  recordsShowPopover: () => void;
  recordsShowRecord: () => void;
  onOrderPress: () => void;
}

export const AllOrganizationClientsContent = ({
  loadingData = {},
  showRecordPopover = noop,
  recordsShowPopover = noop,
  recordsShowRecord = noop,
  onOrderPress = noop,
}: AllOrganizationClientsContentProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: ClientsListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
          onOrderPress,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
